<template>
	<div
		class="bar-greeting"
		:class="{ 'scrolled-down': scrollDown && !$mq.isWV() }"
		v-if="user && user.isNew() && !user.email.includes('guest.quomi.it')"
		v-html="`Ciao ${user.firstname}, ti diamo il benvenuto su Quomi!`"
	/>
</template>

<script>
export default {
	data () {
		return {
			scrollDown: false
		}
	},

	props: {
		show: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	mounted () {
		var currentPosition = 0
		this.$nextTick(function () {
			window.addEventListener('scroll', () => {
				this.scrollDown = window.scrollY > 0
			})
		})
	}
}
</script>

<style scoped>
.bar-greeting {
	position: fixed;
	text-align: center;
	width: 100%;
	font-size: 17px;
	font-weight: bold;
	padding: 5px 0;
	color: white;
	z-index: 3;
	background-color: var(--quomi-orange);
}

.bar-greeting.scrolled-down {
	display: none;
}

</style>
